import { JobAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainJobsSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainJobsSearchRouteData = {
  lang: UserLocale;
  q?: string;
  radius?: number | 'auto' | null;
  saved?: boolean;
  filters?: JobAlgoliaApiQueryFilters;
};

export function getMainJobsSearchRoutePath(data: MainJobsSearchRouteData) {
  const { lang, filters, q, radius } = data;

  const segment = HOME_PAGE_SLUGS.JOB[lang];

  const queryParams: Record<string, unknown> = {};
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;

  if (filters) {
    Object.assign(queryParams, transformSearchFiltersToQueryParams(filters));
  }

  return mainJobsSearchRouteReference.with({ lang, segment, ...queryParams });
}
